module.exports = __webpack_public_path__ + "static/media/kakaotalk.d2616eff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/components/Social/images/kakaotalk.svg
// module id = 821
// module chunks = 0